import { render, staticRenderFns } from "./AddStationPage.vue?vue&type=template&id=06d8cca8&"
import script from "./AddStationPage.vue?vue&type=script&lang=js&"
export * from "./AddStationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports